import { render } from "./OutsideWitness.vue?vue&type=template&id=cbaf2602"
import script from "./OutsideWitness.vue?vue&type=script&lang=js"
export * from "./OutsideWitness.vue?vue&type=script&lang=js"

import "./OutsideWitness.vue?vue&type=style&index=0&id=cbaf2602&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__